import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSearchParams } from 'next/navigation';

interface MobileTableOptionsProps {
  handleSort: (column: string) => void;
  sortConfig: {
    column: string;
    direction: string;
  };
}

export const MobileTableOptions = ({ handleSort, sortConfig }: MobileTableOptionsProps) => {
  const searchParams = useSearchParams();
  const live = searchParams?.get('live') ?? '';

  const getIcon = (column: string) =>
    sortConfig.column === column && sortConfig.direction === 'up' ? faAngleUp : faAngleDown;

  const getTextColorClass = (column: string) =>
    sortConfig.column === column ? 'text-brand-700' : 'text-gray-600';

  return !live ? (
    <div className='container m-0 flex w-full items-center justify-between py-3 pl-3'>
      <div
        className={`flex w-[15%] cursor-pointer items-center justify-start gap-x-2 text-xs ${getTextColorClass('rank')}`}
        onClick={() => handleSort('rank')}
      >
        Rank <FontAwesomeIcon icon={getIcon('rank')} />
      </div>
      <div
        className={`flex w-[35%] cursor-pointer items-center justify-start gap-x-2 pl-4 text-xs ${getTextColorClass('player')}`}
        onClick={() => handleSort('player')}
      >
        Player <FontAwesomeIcon icon={getIcon('player')} />
      </div>
      <div
        className={`flex w-[30%] cursor-pointer items-center justify-center gap-x-2 text-xs ${getTextColorClass('played')}`}
        onClick={() => handleSort('played')}
      >
        Events Played <FontAwesomeIcon icon={getIcon('played')} />
      </div>
      <div
        className={`flex w-[20%] cursor-pointer items-center justify-center gap-x-2 text-xs ${getTextColorClass('points')}`}
        onClick={() => handleSort('points')}
      >
        Points <FontAwesomeIcon icon={getIcon('points')} />
      </div>
    </div>
  ) : (
    <div className='container m-0 flex w-full items-center justify-between py-3 pl-3'>
      <div
        className={`flex w-1/5 cursor-pointer items-center justify-start gap-x-2 text-xs ${getTextColorClass('rank')}`}
        onClick={() => handleSort('rank')}
      >
        Live Rank <FontAwesomeIcon icon={getIcon('rank')} />
      </div>
      <div
        className={`flex w-2/5 cursor-pointer items-center justify-start gap-x-2 pl-4 text-xs ${getTextColorClass('player')}`}
        onClick={() => handleSort('player')}
      >
        Player <FontAwesomeIcon icon={getIcon('player')} />
      </div>
      <div
        className={`flex w-1/5 cursor-pointer items-center justify-center gap-x-2 text-xs ${getTextColorClass('livePoints')}`}
        onClick={() => handleSort('livePoints')}
      >
        Live Points <FontAwesomeIcon icon={getIcon('livePoints')} />
      </div>
      <div
        className={`flex w-1/5 cursor-pointer items-center justify-center gap-x-2 text-xs ${getTextColorClass('nextMaxPoints')}`}
        onClick={() => handleSort('nextMaxPoints')}
      >
        Next/Max Points <FontAwesomeIcon icon={getIcon('nextMaxPoints')} />
      </div>
    </div>
  );
};
